import styled from '@emotion/styled';
export const IntroduceOwnerContainer = styled.article`
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4rem;
	padding: 8rem 0rem;
	@media screen and (max-width: 1370px) {
		padding: 8rem 2rem;
	}
`;

export const OwnerImage = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4rem;
	max-width: 40rem;
	width: 100%;
	img {
		width: 100%;
	}
`;
export const OwnerContentBox = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
`;
export const OwnerTitleBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
`;
export const OwnerTitle = styled.h5`
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	@media screen and (max-width: 900px) {
		font-size: 2.4rem;
	}
`;
export const OwnerContentMenuBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
`;
export const OwnerDescription = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
`;

export const OwnerSubTitle = styled.span`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: 140%;
	letter-spacing: -0.6px;
`;

export const OwnerSign = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	width: 100%;
	align-items: flex-end;
`;

export const OwnerNameBox = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 2rem;
`;
export const OwnerName = styled.div`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	display: flex;
	gap: 0.8rem;

	align-items: center;
	strong {
		font-size: ${(props) => props.theme.fontSize.sizeXl};
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		line-height: 130%;
	}
`;
